function openPopup() {
    // was Destini's product-first pop-up; the in-house store locator replaced it (StoreMap)
    window.location.href = '/pages/store-locator';
}

function closePopup() {
    document.getElementById('popup-widget').style.display = 'none';
    document.body.style.overflow = ''; // Re-enable scrolling
}